import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ApolloClient, ApolloProvider, createHttpLink, from, InMemoryCache } from '@apollo/client';
import { LingoProvider } from '@ttd/lingo/lib/components/LingoProvider';

import { scrollBarStyles, themeStyles } from '@ttd/theme';

import './index.css';
import AuthWrapper, { useAuthLink } from 'Auth';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <AuthWrapper>
            <MainApp />
        </AuthWrapper>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

function MainApp() {
    const { link } = useAuthLink();

    const httpLink = createHttpLink({
        uri: '/graphql',
    });

    const client = new ApolloClient({
        link: from([link, httpLink]),
        cache: new InMemoryCache(),
        connectToDevTools: true,
    });

    return (
        <ApolloProvider client={client}>
            <LingoProvider
                styles={[scrollBarStyles, ...themeStyles]}
                localizationSettings={{
                    locale: 'en-US',
                    strings: {
                        selectAll: 'Select All',
                        clearSearch: 'Clear Search',
                        optional: 'Optional',
                        loading: 'Loading',
                        helpInfo: 'Help Info',
                    },
                }}
                isDev={false}
            >
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </LingoProvider>
        </ApolloProvider>
    );
}
